module.exports = __webpack_public_path__ + "img/ellipsis.b67ca214.png";